var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMap2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M19.8801 20.9401C18.9301 21.6401 17.6801 22.0001 16.1901 22.0001H7.81009C7.57009 22.0001 7.3301 21.9901 7.1001 21.9601L14.0001 15.0601L19.8801 20.9401Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M22.0001 7.80997V16.19C22.0001 17.68 21.6401 18.93 20.9401 19.88L15.0601 14L21.9601 7.09998C21.9901 7.32998 22.0001 7.56997 22.0001 7.80997Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M15.06 14L20.94 19.88C20.65 20.3 20.3 20.65 19.88 20.94L14 15.06L7.10001 21.96C6.46001 21.92 5.88001 21.79 5.35001 21.59C3.21001 20.81 2 18.91 2 16.19V7.81C2 4.17 4.17 2 7.81 2H16.19C18.91 2 20.81 3.21 21.59 5.35C21.79 5.88 21.92 6.46 21.96 7.1L15.06 14Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0601 14L20.9401 19.88C20.6501 20.3 20.3001 20.65 19.8801 20.94L14.0001 15.06L7.1001 21.96C6.4601 21.92 5.8801 21.79 5.3501 21.59L5.74008 21.2L21.5901 5.34998C21.7901 5.87998 21.9201 6.45998 21.9601 7.09998L15.0601 14Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.24 7.93003C11.86 6.28003 10.4001 5.54003 9.12005 5.53003C7.84005 5.53003 6.38006 6.27003 6.00006 7.92003C5.58006 9.75003 6.70005 11.28 7.71005 12.24C8.11005 12.62 8.61005 12.8 9.12005 12.8C9.63005 12.8 10.1301 12.61 10.5301 12.24C11.5401 11.28 12.66 9.75003 12.24 7.93003ZM9.15005 9.49003C8.60005 9.49003 8.15005 9.04003 8.15005 8.49003C8.15005 7.94003 8.59005 7.49003 9.15005 7.49003H9.16006C9.71006 7.49003 10.1601 7.94003 10.1601 8.49003C10.1601 9.04003 9.70005 9.49003 9.15005 9.49003Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap2);
export default __webpack_public_path__ + "static/media/map2.bd5fd470c96d94a521fd2a582da91f1e.svg";
export { ForwardRef as ReactComponent };